@use "Styles/includes/variables";
@use "Styles/mixins";

:host {
    display: flex;
    align-items: center;
    gap: 12px;
    box-sizing: border-box;
    width: 358px;
    padding: 16px;
    border-radius: 8px;
    background-color: mixins.get-color(background, bg-gray-900);
    transition:
        transform 0.3s ease,
        opacity 0.3s ease;

    // Mobile: slide up from below
    transform: translateY(calc(100% + 8px));
    opacity: 0;

    @include mixins.desktop-and-up {
        // Desktop: slide in from the right
        transform: translateX(calc(100% + 24px));
    }

    vm-icon-next {
        flex-shrink: 0;
        color: mixins.get-color(text, text-brand-300);
    }
}

:host([visible]) {
    transform: translate(0, 0);
    opacity: 1;
}

:host([variant="confirmation"]) {
    background-color: mixins.get-color(background, bg-gray-900);

    vm-icon-next,
    .vm-toast__link {
        color: mixins.get-color(text, text-brand-300);
    }
}

:host([variant="error"]) {
    background-color: mixins.get-color(background, bg-error-950);

    .vm-toast__text {
        color: mixins.get-color(text, text-error-100);
    }

    vm-icon-next,
    .vm-toast__link {
        color: mixins.get-color(text, text-error-300);
    }
}

.vm-toast {
    &__text {
        flex: 1;
        font-family: variables.$fontQuaternary;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        color: mixins.get-color(text, text-gray-300);
    }

    &__link {
        flex-shrink: 0;
        color: mixins.get-color(text, text-brand-300);
        text-decoration: none;
        cursor: pointer;
        white-space: nowrap;
        font-size: 14px;
        line-height: 20px;
        font-weight: 700;
    }
}
